import React, {useEffect, useState} from "react";
import { IProps } from "./types";
import cls from "./tabs.module.scss"

const TabsComponent: React.FC<IProps> = ({
                                        item: {
                                            convertedSettings: { styles, parentStyles },
                                            customClassNames,
                                            tabSettings: {
                                                gap,
                                                fontSize,
                                                tabHover,
                                                tabItems = [],
                                                activeTab = {},
                                                boldTabTitle,
                                                fullWidthTabs,
                                            } = {}
                                        }
                                    }) => {

    const isOdd = tabItems.length % 2 === 1;
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const boldTitle = boldTabTitle ? {fontWeight: "bold"} : {};
    const [selected, setSelected] = useState<{ content: string; id: number } | null>(null);
    const borderWidth = activeTab.borderWidth != null ? activeTab.borderWidth : 1;

    useEffect(() => {
        if (tabItems.length > 0) {
            setSelected({ content: tabItems[0].content, id: 0 });
        }
    }, [tabItems]);

    const getTabStyles = (index: number) => {
        return hoveredIndex === index
            ? { ...tabHover, borderWidth: borderWidth, fontSize: `${fontSize}px` }
            : { backgroundColor: styles.backgroundColor, borderWidth: borderWidth, fontSize: `${fontSize}px` };
    }

    return (
        <div className={cls.tabs_component} style={parentStyles}>
            <ul data-tabs={isOdd} style={{...styles, gap: `${gap}px`}} className={`${cls.tabsList} ${customClassNames} ${fullWidthTabs ? cls.fullWidthTabs : ''}`}>
                {tabItems.map(({ title, content, }, index) => {
                    const selectedTab = selected?.id === index
                        return (
                            <li
                                key={index}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    if (!selectedTab) {
                                        setSelected({ content, id: index });
                                    }
                                }}
                                style={ selectedTab ? {...activeTab, fontSize: `${fontSize}px`} : getTabStyles(index)}
                                className={`${cls.tabsListItem} ${selectedTab && cls.selectedItem}`}
                            >
                                <span
                                    style={selectedTab ? boldTitle : {}}
                                    className={cls.tabsListItemTitle}>
                                    {title}
                                </span>
                            </li>
                        )
                    }
                )}
            </ul>
            {selected && (
                <div className={cls.dropListItemDecr} >
                    <div className={cls.content} dangerouslySetInnerHTML={{ __html: selected.content }} />
                </div>
            )}
        </div>)
}

export default TabsComponent;